import { useRef, useEffect } from 'react';
function useRowRef(rowData, rowIndex, setRowHeight) {
  var rowRef = useRef();
  useEffect(function () {
    setRowHeight(rowIndex, rowRef.current.offsetHeight);
  }, [rowRef, rowData, setRowHeight, rowIndex]);
  return rowRef;
}
export default useRowRef;